import React from "react"
import { Row, Col, Card, CardBody, CardTitle, Container } from "reactstrap"
import HighchartsReact from "highcharts-react-official"
import Highcharts from "highcharts"

function CrowdChart({ data }) {
  const chartData = [
    { date: "2025-02-21", highScore: 30, avgScore: 10 },
    { date: "2025-02-22", highScore: 62, avgScore: 46 },
    { date: "2025-02-23", highScore: 115, avgScore: 85 },
    { date: "2025-02-24", highScore: 95, avgScore: 68 },
    { date: "2025-02-25", highScore: 125, avgScore: 115 },
    { date: "2025-02-26", highScore: 165, avgScore: 110 },
    { date: "2025-02-27", highScore: 155, avgScore: 70 },
    { date: "2025-02-28", highScore: 122, avgScore: 87 },
    { date: "2025-02-29", highScore: 101, avgScore: 71 },
    { date: "2025-02-30", highScore: 95, avgScore: 50 },
  ]

  //   const testData = [
  //     { week: "2025-W11", user: 130, test: 285 },
  //     { week: "2025-W10", user: 232, test: 296 },
  //     { week: "2025-W24", user: 15, test: 87 },
  //     { week: "2025-W01", user: 285, test: 187 },
  //     { week: "2025-W01", user: 285, test: 187 },
  //     { week: "2025-W01", user: 285, test: 187 },
  //     { week: "2025-W01", user: 285, test: 187 },
  //     { week: "2025-W01", user: 285, test: 187 },
  //     { week: "2025-W01", user: 285, test: 187 },
  //     { week: "2025-W01", user: 285, test: 187 },
  //     { week: "2025-W01", user: 285, test: 187 },
  //   ]

  //   const chartMonth = [
  //     { month: "April 2025", user: 130, test: 285 },
  //     { month: "May 2024", user: 232, test: 296 },
  //     { month: "June 2024", user: 15, test: 87 },
  //     { month: "January 2025", user: 285, test: 187 },
  //     { month: "January 2025", user: 2085, test: 187 },
  //     { month: "January 2025", user: 285, test: 187 },
  //     { month: "January 2025", user: 285, test: 187 },
  //     { month: "January 2025", user: 285, test: 1807 },
  //     { month: "January 2025", user: 285, test: 187 },
  //     { month: "January 2025", user: 285, test: 187 },
  //     { month: "January 2025", user: 285, test: 187 },
  //     { month: "January 2025", user: 285, test: 187 },
  //   ]
  //   console.log("chart data", chartData)
  const labels = data.map(item => item.date)
  const highScore = data.map(item => item.highScore)
  const avgScore = data.map(item => item.avgScore)
  const nop = data.map(item => item.nop)
  const noOfJoinVirtualUser = data.map(item => item.noOfJoinVirtualUser)

  const chartOptions = {
    chart: {
      zooming: {
        type: "xy",
      },
    },
    title: {
      text: "Crowd Scores", // Remove chart title
    },
    credits: {
      enabled: false, // Remove Highcharts watermark
    },
    xAxis: {
      categories: labels,
      crosshair: true,
    },
    yAxis: [
      {
        // Primary Y Axis
        labels: {
          format: "{value}",
          style: { color: "#2196F3" },
        },
        title: {
          text: "Scores",
          style: { color: "#2196F3" },
        },
      },
      {
        // Secondary Y Axis
        title: {
          text: "Virtual / Participants",
          style: { color: "#6ac819" },
        },
        labels: {
          format: "{value}",
          style: { color: "#6ac819" },
        },
        opposite: true,
      },
    ],

    tooltip: {
      shared: true,
      valueSuffix: "",
    },
    legend: {
      layout: "vertical",
      align: "left",
      x: 80,
      verticalAlign: "top",
      y: 55,
      floating: true,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor ||
        "rgba(255,255,255,0.25)",
    },
    series: [
      {
        name: "High Score",
        type: "spline",
        data: highScore,
        color: "#2196F3",
        tooltip: { valueSuffix: "" },
        yAxis: 0,
      },
      {
        name: "Average Score",
        type: "spline",
        data: avgScore,
        color: "#dd0da5",
        tooltip: { valueSuffix: "" },
        yAxis: 0,
      },
      {
        name: "Virtual Users",
        type: "column",
        data: noOfJoinVirtualUser,
        color: "rgba(240, 49, 24, 0.61)",
        yAxis: 1,
        tooltip: { valueSuffix: "" },
      },
      {
        name: "Participants",
        type: "column",
        data: nop,
        color: "rgba(125, 236, 156, 0.47)",
        yAxis: 1,
        tooltip: { valueSuffix: "" },
      },
    ],
  }
  console.log("data from crowd chart", data)
  return (
    <div>
      <div className="border border-gray-300 rounded-lg ">
        <Card>
          <CardBody>
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default CrowdChart
